"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Queue = void 0;
var tslib_1 = require("tslib");
var Queue = (function () {
    function Queue() {
        this.isProcessing = false;
        this.queue = [];
    }
    Queue.prototype.process = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var e_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.isProcessing = true;
                        if (!this.queue.length) {
                            this.isProcessing = false;
                            return [2];
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 6]);
                        return [4, this.queue.shift()()];
                    case 2:
                        _a.sent();
                        return [3, 6];
                    case 3:
                        e_1 = _a.sent();
                        console.error("Error processing queue: ".concat(e_1));
                        return [3, 6];
                    case 4: return [4, this.process()];
                    case 5:
                        _a.sent();
                        return [7];
                    case 6: return [2];
                }
            });
        });
    };
    Queue.prototype.startProcessing = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!!this.isProcessing) return [3, 2];
                        return [4, this.process()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2];
                }
            });
        });
    };
    Queue.prototype.push = function (callback, shouldStartProcessing) {
        if (shouldStartProcessing === void 0) { shouldStartProcessing = true; }
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.queue.push(callback);
                        if (!shouldStartProcessing) return [3, 2];
                        return [4, this.startProcessing()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2];
                }
            });
        });
    };
    return Queue;
}());
exports.Queue = Queue;
//# sourceMappingURL=utils.js.map